import { ThemedToastProps } from '@/Toast';
import { ThemeProps } from '@/withTheme';
import { create } from 'zustand'
interface ToastState {
    toasts: (ThemedToastProps & { id: number; })[];
    add: (message: string, color?: ThemeProps['color']) => void;
    remove: (id: number) => void;
}
export const useToastStore = create<ToastState>((set) => ({
    toasts: [],
    add: (message, color = 'primary') => {
        const id = Date.now();

        const newToast: ToastState['toasts'][0] = {
            message,
            color,
            id,
            visible: true,
        }

        return set(({ toasts }) => {
            const last = toasts[toasts.length - 1];
            if (
                last?.message === newToast.message
            )
                last.duplicated = true
            return {
                toasts: [...toasts, newToast]
            }
        })
    },
    remove: (id) => {
        set(({ toasts }) => ({ toasts: toasts.map(toast => toast.id === id ? { ...toast, visible: false } : toast) })); // remove 후 일정 시간이 지나면 토스트 자동 제거 
        setTimeout(() => { set(({ toasts }) => ({ toasts: toasts.filter(toast => toast.id !== id) })); }, 500); // 0.5초 후 실제 제거 
    },
}))
